import React from 'react';
import { Box } from '@mui/material';
import VerticalSwitch from "../../ui/VerticalSwitch";
import Typography from "@mui/material/Typography";
import PowerRegulatorComponent from "./components/PowerRegulatorComponent";
import Slider3PosComponent from "./components/Slider3PosComponent";
import RadioButtonCheckedIcon from "@mui/icons-material/RadioButtonChecked";
import HeightIcon from '@mui/icons-material/Height';
import RightRegulatorComponent from "./components/RightRegulatorComponent";
import Slider4PosComponent from "./components/Slider4PosComponent";
import MiddleRegulator from "./components/MiddleRegulatorComponent";
import MonitorComponent from "./components/MonitorComponent";
import {middleRegulatorsUkrNames, middleRegulatorsEngNames} from '../../../constants/constants';
import useStore from "../../../store/store";
import style from './Oscilloscope.css'

export default function Oscilloscope() {

    const oscillatorOn = useStore((state) => state.oscillatorOn);
    const toggleOscillator = useStore((state) => state.toggleOscillator);
    const eng = useStore((state) => state.eng);

    const activeExitGenerator = useStore((state) => state.activeExitGenerator);
    const activeEnterOcsilloscope = useStore((state) => state.activeEnterOcsilloscope);
    const activeEnterMembrane = useStore((state) => state.activeEnterMembrane);
    const activeExitMembrane = useStore((state) => state.activeExitMembrane);

    const changeActiveExitMembrane = useStore((state) => state.changeActiveExitMembrane);
    const changeActiveEnterOcsilloscope = useStore((state) => state.changeActiveEnterOcsilloscope);
    const changeActiveEnterMembrane = useStore((state) => state.changeActiveEnterMembrane);
    const changeActiveExitGenerator = useStore((state) => state.changeActiveExitGenerator);

    const resetAllWires = useStore((state) => state.resetAllWires);
    const resetFullWires = useStore((state) => state.resetFullWires);

    const changeExitGenerator_EnterMembrane = useStore((state) => state.changeExitGenerator_EnterMembrane);
    const changeExitMembrane_enterOcsilloscope = useStore((state) => state.changeExitMembrane_enterOcsilloscope);



    // RIGHT
    const changeActiveEnterOcsilloscope1Handle = () => {
        if (!activeExitMembrane && !activeExitGenerator && !activeEnterMembrane){
            changeActiveEnterOcsilloscope()
        }

        if (!activeExitMembrane && (activeEnterMembrane || activeExitGenerator)){
            alert ('Hе правильно з\'єднали!')
            resetFullWires()
        }

        if (activeExitMembrane){
            changeActiveEnterOcsilloscope()
            changeExitMembrane_enterOcsilloscope()
            resetAllWires()
        }
    }

    return (
        <Box className="ocsilloscopeFull">
            <Box sx={{display: 'flex', flexDirection: 'column'}}>
            </Box>
            {/* ------------------------------------------  FIRST BOX ---------------------------------------------------*/}
            <Box sx={{display: 'flex', flexDirection: 'column', flex: 1, justifyContent: 'space-between', alignItems: 'center' }}>
                <Box sx={{display: 'flex', flexDirection: 'row', justifyContent: 'space-between'}}>
                        <Box></Box>
                </Box>
                <Typography sx={{display: 'flex', fontWeight: 'bold', marginRight: '70px'}}>{eng ? 'V/div' : 'V/дiл'}</Typography>
                <PowerRegulatorComponent eng={eng}/>
                <Slider3PosComponent/>
                <Box sx={{display: 'flex', flexDirection: 'row', width: 140, justifyContent: 'space-between'}}>
                    <Box><img src='/symbolTilde.png' alt="tilde" width='15' height='15'
                              style={{backgroundColor: 'transparent'}}/></Box>
                    <Box><img src='/symbolT.png' alt="t-reverse" width='15' height='15'
                              style={{backgroundColor: 'transparent', transform: 'rotateX(-180deg)' }} /></Box>
                    <Box><img src='/symbolADC.png' alt="adc" width='15' height='15' style={{ backgroundColor: 'transparent' }} /></Box>
                </Box>
            </Box>
            {/* ------------------------------------------  SECOND BOX ---------------------------------------------------*/}
            <Box sx={{display: 'flex', flexDirection: 'column', flex: 1, justifyContent: 'space-around', alignItems: 'center'}}>
                <Box sx={{marginLeft: '25px', color: 'black', fontWeight: 'bold', fontSize: 'large', zIndex: 1000, marginBottom: '5px', marginTop: '5px'}}> {eng ? 'Oscilloscope' : 'Осцилограф'}</Box>

                <MonitorComponent />

                <Box sx={{display: 'flex'}}>
                    <MiddleRegulator regulatorName={eng ? middleRegulatorsEngNames.ENGFOCUSNAME : middleRegulatorsUkrNames.RUSFOCUSNAME} />
                    <MiddleRegulator regulatorName={eng ? middleRegulatorsEngNames.ENGBRIGHTNAME : middleRegulatorsUkrNames.RUSBRIGHTNAME} />
                    <MiddleRegulator regulatorName={eng ? middleRegulatorsEngNames.ENGSTABNAME : middleRegulatorsUkrNames.RUSSTABNAME} />
                    <MiddleRegulator regulatorName={eng ? middleRegulatorsEngNames.ENGLEVELNAME : middleRegulatorsUkrNames.RUSLEVELNAME} />
                </Box>
            </Box>
            {/* ------------------------------------------  THIRD BOX ---------------------------------------------------*/}
            <Box sx={{display: 'flex', flexDirection: 'column', flex: 1, alignItems: 'center', justifyContent: 'space-between' }}>
                <Box sx={{display: 'flex', flexDirection: 'row', alignItems: 'center', alignSelf: 'end', justifyContent: 'space-evenly'}}>
                    <Box sx={{display: 'flex', flexDirection: 'column', alignItems: 'center',}}>
                        <Typography sx={{fontWeight: 'bold'}}>{eng ? 'SUPPLY' : 'ЖИВЛЕННЯ'}</Typography>
                        <Box
                            sx={{
                                width: '20px',
                                height: '20px',
                                borderRadius: '50%',
                                backgroundColor: oscillatorOn ? 'red' : 'grey',
                            }}
                        />
                    </Box>
                    <Box sx={{marginLeft: '5px', marginTop: '0'}}><VerticalSwitch
                        onChange={toggleOscillator}/></Box>
                </Box>
                <Box sx={{display: 'flex', flexDirection: 'row'}}>
                    <Box sx={{marginRight: '-60px'}}>
                        <RightRegulatorComponent eng={eng}/>
                    </Box>

                    <Box sx={{display: 'flex', flexDirection: 'column', marginTop: '1px', marginLeft: `${eng ? '120px' : '120px'}`, zIndex: 2}}>
                        <Typography>{eng ? 'Enter' : 'Вхід'}</Typography>
                        <Box
                            sx={{
                                width: '20px',
                                height: '20px',
                                borderRadius: '50%',
                                border: 'solid 15px black',
                                cursor: 'pointer',
                                backgroundColor: 'gray',
                            }}
                            onClick={changeActiveEnterOcsilloscope1Handle}
                        />
                    </Box>
                </Box>

                    <Box sx={{display: 'flex', flexDirection: 'column'}}>
                        <Slider4PosComponent />
                        <Box sx={{display: 'flex', flexDirection: 'row', width: 140, justifyContent: 'space-between'}}>
                            <Box sx={{fontWeight: 'bold'}}>+</Box>
                            <Box sx={{fontWeight: 'bold'}}>-</Box>
                            <Box sx={{fontWeight: 'bold'}}>+</Box>
                            <Box sx={{fontWeight: 'bold'}}>-</Box>
                        </Box>
                        <Box sx={{display: 'flex', justifyContent: 'space-between', marginTop: '10px'}}>
                            <Box><img src='/symbolADC.png' alt="adc" width='15' height='15' style={{ display: 'flex', backgroundColor: 'transparent', alignSelf: 'end', justifySelf: 'end' }} /></Box>
                            <Typography sx={{fondWeight: 'bold'}}>{eng ? 'SYNCHR' : 'СИНХР.'}</Typography>
                            <Box><img src='/symbolTilde.png' alt="adc" width='15' height='15' style={{ display: 'flex', backgroundColor: 'transparent', alignSelf: 'end' }} /></Box>
                        </Box>
                    </Box>

            </Box>
        </Box>
    );
}
